import { apiFetch } from './client';

const BASE = '/connector-subscriptions/klaviyo';

/**
 * Get the authenticated client's Klaviyo subscription. Scoped server-side to
 * the caller's tenant -- no subscription id or customer id is sent here.
 */
export const get = ({ signal } = {}) => apiFetch(BASE, { signal });

/**
 * Create the Klaviyo subscription (API-key mode). Requires api_key and name.
 * Do not send a customer field -- the server derives it from the caller's tenant.
 */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/**
 * Partial-update the Klaviyo subscription. Only non-null fields are applied --
 * a field cannot be explicitly nulled this way.
 */
export const update = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Disconnect Klaviyo -- deletes the subscription and its child rows. */
export const remove = ({ signal } = {}) => apiFetch(BASE, { method: 'DELETE', signal });

/** Get the subscription's activity summary. */
export const getSummary = ({ signal } = {}) => apiFetch(`${BASE}/summary`, { signal });

/** Rotate the webhook signing secret. */
export const rotateWebhookSecret = ({ signal } = {}) =>
  apiFetch(`${BASE}/webhook-secret`, { method: 'POST', signal });

/**
 * Get the webhook signing secret. Not called on mount by any consumer -- it is
 * fetched only when a user explicitly asks to reveal it, so it never rides
 * along on the page-load path (request logs, error reports, etc).
 */
export const getWebhookSecret = ({ signal } = {}) => apiFetch(`${BASE}/webhook-secret`, { signal });

/**
 * Get Klaviyo's OAuth install URL. Scoped server-side to the caller's tenant --
 * no customer id or other identifier is sent here.
 */
export const getOAuthUrl = ({ signal } = {}) => apiFetch(`${BASE}/oauth-url`, { signal });
